import { Bars } from "react-loader-spinner";
import styles from "./Loader.module.css";
import Modal from "./Modal";

export default function Loader() {
    return (
        <Modal>
            <Bars
                visible={true}
                margin="50"
                height="90"
                width="90"
                color="#93C021"
                radius="9"
                ariaLabel="three-dots-loading"
                wrapperStyle={{}}
                wrapperClass=""
            />
        </Modal>
    );
}
